"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var recommended_actions_1 = require("../../sections/recommended-actions");
/**
 * Recommended Section Constructor
 */
wp.customize.sectionConstructor['epsilon-section-recommended-actions'] = wp.customize.Section.extend({
    ready: function () {
        new recommended_actions_1.EpsilonSectionRecommended(this);
    },
    attachEvents: function () {
    },
    isContextuallyActive: function () {
        return true;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/sections/recommended-actions.ts
// module id = 26
// module chunks = 0